import {
    apiClient as api
} from './APIService'

export const postNewRemix = (trackId, revisionStrings, userId) => {
    return api.post(
        "/newRevision",
        {
            trackId,
            mixName: "mix",
            revisionStrings,
            userId,
            groupNames: "group",
            userName: localStorage.getItem("mxdUserName"),
        },
        {
            headers: { "x-access-token": localStorage.getItem("jwt") },
        }
    );
}